import { AEMErrorMessage } from '@com-delta-idp/mnx-skymiles-shared';

export const ErrorMessagesMocks: AEMErrorMessage[] = [
  {
    action: {
      label: '',
      url: '',
      id: ''
    },
    component: 'educational-content',
    errorId: [
      {
        errorCode: '500'
      }
    ],
    featureTitle: '',
    errorMessageDescription:
      'Sorry, we’re currently unable to display this content. Please try again later',
    errorMessageTitle: '',
    type: 'single-error'
  }
];
